    import React from 'react'
    import {Box, Button, Grid, Typography} from "@mui/material";
    import useStyles from "../../assets/styles/HomeStyles";

    const DQProSalesResources = () => {
        const classes = useStyles();
        const cards = [
            {
                title: "DQ Scoring Rubrics and Suggestions for Client Consultation",
                description: "Understand what DQ Scores mean so you can follow up with your clients and consult them on next steps after they’ve taken the assessments.",
                button: {
                    text: "Coming Soon",
                    link: null
                },
            },
            {
                title: "Editable Standard Sales Deck",
                description: "Standard PPT sales deck that you can edit and adjust to sell to your schools, organizations, and communities.",
                button: {
                    text: "Download",
                    link: "https://www.canva.com/design/DAG0dT2axQc/8YuDQaBSq7GGezbfx2ICdA/edit?utm_content=DAG0dT2axQc&utm_campaign=designshare&utm_medium=link2&utm_source=sharebutton"
                },
            },
            {
                title: "CSV Instructions for Your Clients",
                description: "Detailed document you can share with your clients on how to set up their learners’ accounts.",
                button: {
                    text: "Download",
                    link: "https://storage.googleapis.com/poweredbydq/resources/CSV%20Instructions%20for%20Admin_%20User%20Account%20Creation%20v1.pdf"
                },
            },
            {
                title: "Parental Data Consent Forms and Letters",
                description: "Template consent forms and letters for parents if you’re dealing with schools minors directly.",
                button: {
                    text: "Download",
                    link: "https://storage.googleapis.com/poweredbydq/resources/Sample%20Parental%20Consent%20Form%20and%20Letter%20v1.pdf"
                }
            },
        ];
    
        return (
            <Box
                className={classes.pageContainer}
                sx={{
                    marginTop: { xs: '56px', sm: '72px', md: '80px', lg: 'auto' },
                    paddingTop: { xs: 1, sm: 2, lg: 0 },
                }}
            >
                <Typography variant="h2" className={classes.title} sx={{ mb: 4 }}>
                    Sales Resources
                </Typography>

                <Grid
                    container
                    spacing={4}
                    sx={{
                        marginTop: { xs: 2, sm: 2, md: 2, lg: 1 },
                    }}
                >
                    {cards.map((card, index) => (
                        <Grid item xs={12} sm={6} md={3} key={index} >
                            <Box
                                sx={{
                                    p: 3,
                                    height: '450px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    minHeight: '400px',

                                }}
                            >
                                {/* Fixed-height title so all cards align; font scales so longest title fits */}
                                <Box
                                    sx={{
                                        width: '100%',
                                        height: { xs: 100, sm: 100, md: 120, lg: 150, xl: 120, },
                                        flexShrink: 0,
                                        mb: 2,
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        justifyContent: 'center',
                                        textAlign: 'center',
                                        overflow: 'visible',
                                    }}
                                >
                                    <Typography
                                        variant="h4"
                                        sx={{
                                            fontWeight: 'bold',
                                            fontSize: '25px',
                                            color: '#000000',
                                            lineHeight: 1.3,
                                        }}
                                    >
                                        {card.title}
                                    </Typography>
                                </Box>

                                {/* Description: fixed flex space so button always at same position; scroll if long */}
                                <Box
                                    sx={{
                                        flex: 1,
                                        width: '100%',
                                        minHeight: 0,
                                        overflow: 'auto',
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontSize: { xs: '16px', sm: '17px', md: '19px' },
                                            textAlign: 'left',
                                            lineHeight: 1.4,
                                        }}
                                    >
                                        {card.description}
                                    </Typography>
                                </Box>

                                {/* Button aligned at bottom – same position in every card */}
                                <Box sx={{ mt: 'auto', flexShrink: 0, width: '100%' }}>
                                    {card.button && (
                                        <Button
                                            variant="contained"
                                            href={card.button.link}
                                            download
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            sx={{
                                                backgroundColor: '#ff6468',
                                                width: '100%',
                                                fontWeight: 'bold',
                                                fontSize: '16px',
                                                borderRadius: '20px',
                                                '&:hover': {
                                                    backgroundColor: '#e05559',
                                                    color: '#ffffff'
                                                }
                                            }}
                                        >
                                            {card.button.text}
                                        </Button>
                                    )}
                                </Box>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        );
    }
    
    export default DQProSalesResources;